








































































































































































































































































































































import { Component, Vue, Watch, Prop, Ref } from 'vue-property-decorator'
import Evaluation from '@/evaluations/entities/evaluation'
import EvaluationBasicDto from '@/evaluations/models/evaluation-basic-dto'
import JudgeDialog from '@/evaluations/components/judge-dialog.vue'
import AddJudgesDialog from '@/evaluations/components/add-judges-dialog.vue'
import Judge from '@/evaluations/entities/judge'
import CandidateDialog from '@/evaluations/components/candidate-dialog.vue'
import JudgesFilter from '@/evaluations/entities/judges-filter'
import CandidatesFilter from '@/evaluations/entities/candidates-filter'
import Candidate from '@/evaluations/entities/candidate'
import ConfirmDialog from '@/common/components/confirm-dialog.vue'
import Competence from '@/competences/entities/competence'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import CompetenceDialog from '@/competences/components/competence-dialog.vue'
import QuestionsDialog from '@/competences/components/questions-dialog.vue'
import evaluationService from '@/evaluations/services/evaluation-service'
import judgeService from '@/evaluations/services/judge-service'
import candidateService from '@/evaluations/services/candidate-service'
import evaluationCompetencesService from '@/competences/services/evaluation-competences-service'
import competencesService from '@/competences/services/competences-service'
import PreviewDialog from '../components/preview-dialog.vue'

import {
  isDraft,
  isInProgress,
  isFinished,
} from '@/evaluations/utils/evaluation-states'
import Guid from '@/app/utils/guid'
import bus from '@/app/bus'
import snacks from '@/app/services/snacks'
import JudgesTable from '../components/judges-table.vue'

@Component
export default class EvaluationSettings extends Vue {
  private e1 = 1
  // private dtoEvaluation = new EvaluationBasicDto()
  private evaluation = new Evaluation()
  private competencePaging = new PaginationRequest()

  private judgesFilter = new JudgesFilter()
  private candidatesFilter = new CandidatesFilter()

  @Prop({ type: String })
  private id!: string

  @Ref()
  private competenceDialog!: CompetenceDialog
  @Ref()
  private removeCompetenceConfirmDialog!: ConfirmDialog
  @Ref()
  private questionsDialog!: QuestionsDialog
  @Ref()
  private judgeDialog!: JudgeDialog
  @Ref()
  private addJudgesDialog!: AddJudgesDialog
  @Ref()
  private candidateDialog!: CandidateDialog
  @Ref()
  private confirmCandidateDialog!: ConfirmDialog
  @Ref()
  private confirmCandidateDialogWithRatings!: ConfirmDialog
  @Ref()
  private confirmJudgeDialog!: ConfirmDialog
  @Ref()
  private previewDialog!: PreviewDialog

  private loadingReport = false

  private showInfo() {
    bus.$emit(
      'app.help-dialog.show',
      `<h2 name="evaluations-edit">Evaluierung erstellen oder bearbeiten</h2>
</br>
<p>
  Das Erstellen bzw. Bearbeiten einer Evaluierung ist in einen Vorgang mit 4
  Schritten unterteilt.
</p>

<ol>
  <li>
    <strong>Grunddaten:</strong> Im ersten Schritt legen Sie fest, wie die
    Evaluierung heisst, für welche Firma sie durchgeführt wird und wer sie
    moderiert. Ein(e) Expert:in kann aus der Liste der Benutzer die bereits
    im System angelegt sind ausgewählt werden, oder es kann mit Klick auf das
    Symbol neben der Auswahllliste ein(e) neue(r) Expert:in angelegt werden.
  </li>
  <li>
    <strong>Kompetenzen:</strong> Hier können Sie Kompetenzen aus der
    <a href="#competences">Kompetenzbibliothek</a> auswählen, oder direkt neue
    Kompetenzen anlegen. Bitte beachten Sie, dass Kompetenzen die in einer
    Evaluierung angelegt werden, auch nur innerhalb dieser Evaluierung
    ausgewählt werden können.<br />
    Zusätzlich legen Sie an dieser Stelle fest, was der gewünschte Sollwert der
    Kompetenz ist, die von den Kandidat:innen erwartet wird. Im Vergleich mit
    dem von den Assessoren vergebenen Istwert ergibt sich am Ende dann die
    Beurteilung der Kandidat:in.
  </li>
  <li>
    <strong>Assessoren:</strong> Hier können Sie die Assessoren eingeben, die an
    der Beurteilung der Mitarbeiter:innen mitwirken sollen. Bitte achten Sie
    sehr genau auf die Eingabe einer korrekten E-Mail-Adresse, da Assessoren den
    Link zum Bewertungsformular an diese Adresse zugesandt bekommen. Der Versand
    der E-Mails erfolgt, sobald die Evaluierung gestartet wird.
  </li>
  <li>
    <strong>Kandidat:innen:</strong> Bitte geben Sie hier die Liste der
    Kandidat:innen für die Evaluierung ein.
  </li>
</ol>
      `
    )
  }

  private get isUnsaved() {
    return this.evaluation.id == Guid.empty()
  }

  private get isDraft() {
    return isDraft(this.evaluation.status)
  }

  private get isInProgress() {
    return isInProgress(this.evaluation.status)
  }

  private get isFinished() {
    return isFinished(this.evaluation.status)
  }

  // private get finishDisabled() {
  //   return isFinished
  // }

  private cancel() {
    this.$router.back()
  }

  // --- Competences

  private async selectCompetence(competence: Competence | null) {
    if (competence) {
      await evaluationCompetencesService.linkAsync(
        this.evaluation.id,
        competence.id
      )
      await this.loadEvaluation()
    }
  }

  private async createCompetence(competence: Competence) {
    this.competenceDialog.openNew(competence)
  }

  private async createCompetenceConfirmed(competence: Competence) {
    await evaluationCompetencesService.createAndLinkAsync(
      this.evaluation.id,
      competence
    )
    await this.loadEvaluation()
  }

  private editCompetence(competence: Competence) {
    this.competenceDialog.openEdit(competence)
  }

  private async updateCompetence(competence: Competence) {
    await competencesService.updateAsync(competence)
    await this.loadEvaluation()
  }

  private async removeCompetence(competence: Competence) {
    this.removeCompetenceConfirmDialog.open(competence)
  }

  private async removeCompetenceConfirmed(competence: Competence) {
    await competencesService.removeAsync(competence.id)
    await this.loadEvaluation()
  }

  private async moveUp(competence: Competence) {
    await competencesService.moveUpAsync(competence.id)
    await this.loadEvaluation()
  }

  private async moveDown(competence: Competence) {
    await competencesService.moveDownAsync(competence.id)
    await this.loadEvaluation()
  }

  private openQuestions(competence: Competence) {
    this.questionsDialog.openQuestions(competence)
  }

  private openPreviewDialog() {
    this.previewDialog.open(this.evaluation)
  }

  private async downloadCompetencesReport() {
    this.loadingReport = true
    var url = await evaluationService.generateCompetencesReportAsync(this.id)
    if (url) {
      window.open(url)
    }
    this.loadingReport = false
  }

  // --- Candidates

  private createCandidate() {
    this.candidateDialog.openNew(new Candidate())
  }

  private editCandidate(candidate: Candidate) {
    this.candidateDialog.openEdit(candidate)
  }

  private async createCandidateCompleted(candidate: Candidate) {
    if (this.evaluation != null) {
      candidate.evaluationId = this.evaluation.id
    }

    await candidateService.createAsync(candidate)
    await this.loadEvaluation()
  }

  private async editCandidateCompleted(candidate: Candidate) {
    await candidateService.updateAsync(candidate)
    await this.loadEvaluation()
  }

  private removeCandidate(candidate: Candidate) {
    this.confirmCandidateDialog.open(candidate)
  }

  private async removeCandidateConfirmed(candidate: Candidate) {
    var hasRatings = await candidateService.hasRatings(candidate.id)
    if (hasRatings) {
      this.confirmCandidateDialogWithRatings.open(candidate)
    } else {
      await this.removeCandidateIntern(candidate)
    }
  }

  private async removeCandidateConfirmedWithRatings(candidate: Candidate) {
    await this.removeCandidateIntern(candidate)
  }

  private async removeCandidateIntern(candidate: Candidate) {
    await candidateService.deleteAsync(candidate.id)
    await this.loadEvaluation()
  }

  private async sendPreview(
    emailSender: string,
    emailRecipient: string,
    message: string,
    evaluationId: string
  ) {
    this.loadingReport = true
    var url = await evaluationService.generateAndSendPreviewAsync(
      evaluationId,
      emailSender,
      emailRecipient,
      message
    )
    this.loadingReport = false
    snacks.success('evaluations.pages.evaluation-details.guide_sent')
  }

  // --- Judges

  private createJudge() {
    let judges = []
    judges.push(new Judge())
    judges.push(new Judge())
    judges.push(new Judge())
    judges.push(new Judge())
    judges.push(new Judge())
    this.addJudgesDialog.openNew(judges)
  }

  private editJudge(judge: Judge) {
    this.judgeDialog.openEdit(judge)
  }

  private async createJudgeCompleted(judge: Judge) {
    if (this.evaluation != null) {
      judge.evaluationId = this.evaluation.id
    }

    await judgeService.createAsync(judge)
    await this.loadEvaluation()
  }

  private async createJudgesCompleted(judges: Judge[]) {
    if (this.evaluation != null) {
      judges.forEach((j) => (j.evaluationId = this.evaluation.id))
    }
    for (const judge of judges) {
      if (judge.email && judge.email.length > 0) {
        await judgeService.createAsync(judge)
      }
    }
    await this.loadEvaluation()
  }

  private async updateJudgeCompleted(judge: Judge) {
    await judgeService.updateAsync(judge)
    await this.loadEvaluation()
  }

  private removeJudge(judge: Judge) {
    this.confirmJudgeDialog.open(judge)
  }

  private async sendRatingLink(judge: Judge) {
    const res = await evaluationService.sendRating(this.id, judge.id)
    if (res) {
      snacks.success('evaluations.pages.evaluation-details.rating_sent')
    } else {
      snacks.success('evaluations.pages.evaluation-details.rating_sent_failed')
    }
  }

  private async confirmJudgeConfirmed(judge: Judge) {
    await judgeService.deleteAsync(judge.id)
    await this.loadEvaluation()
  }

  private goToJudgeRatePage(judge: Judge) {
    const routeData = this.$router.resolve({
      name: 'ratinglist',
      params: {
        lang: this.$i18n.locale,
        eId: this.id,
        jId: judge.id,
      },
    })
    window.open(routeData.href, '_blank')
  }

  // --- Evaluations

  private async createEvaluation() {
    const dto = new EvaluationBasicDto()
    dto.id = this.evaluation?.id
    dto.title = this.evaluation?.title
    dto.description = this.evaluation?.description
    dto.companyName = this.evaluation?.companyName
    dto.moderatorId = this.evaluation?.moderatorId
    dto.remarks = this.evaluation?.remarks
    dto.applicationsCount = this.evaluation?.applicationsCount
    dto.dbApplicationsCount = this.evaluation?.dbApplicationsCount
    dto.interviewsCount = this.evaluation?.interviewsCount
    dto.referenceNumber = this.evaluation?.referenceNumber

    if (this.evaluation == null || this.evaluation.id === Guid.empty()) {
      let saved = await evaluationService.createAsync(dto)
      if (this.evaluation && saved) {
        ;(this.evaluation.id = saved.id), (this.id = saved.id)
      }
    } else {
      if (this.isDraft || this.isInProgress) {
        await evaluationService.updateAsync(dto)
      }
    }

    await this.loadEvaluation()

    this.e1 = 2
  }

  private async loadEvaluation() {
    if (this.id != null) {
      const tmp = await evaluationService.findOneAsync(this.id)
      if (tmp) {
        this.evaluation = tmp

        this.competencePaging.totalItems =
          this.evaluation.competences?.length || 0

        this.judgesFilter.paging.totalItems =
          this.evaluation.judges?.length || 0

        this.candidatesFilter.paging.totalItems =
          this.evaluation.candidates?.length || 0
      }
    }
  }

  private async mounted() {
    await this.loadEvaluation()
  }
}
